import { useGlobalState } from 'context/GlobalStateContext'
import { errorHandler } from './errorHandler'

/**
 * returns the current project and baseURL for report urls
 */
export function useReportURLDependencies() {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  if (!projectId) throw errorHandler('projectId is not defined')
  const baseURL = process.env.REACT_APP_BACK_END_URL
  if (!baseURL) throw errorHandler('REACT_APP_BACK_END_URL is not defined')
  return { projectId, baseURL }
}
